/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LanguageEnum } from './LanguageEnum';
import {
    LanguageEnumFromJSON,
    LanguageEnumFromJSONTyped,
    LanguageEnumToJSON,
    LanguageEnumToJSONTyped,
} from './LanguageEnum';

/**
 * 
 * @export
 * @interface PartnerEmailInput
 */
export interface PartnerEmailInput {
    /**
     * 
     * @type {LanguageEnum}
     * @memberof PartnerEmailInput
     */
    language?: LanguageEnum;
}



/**
 * Check if a given object implements the PartnerEmailInput interface.
 */
export function instanceOfPartnerEmailInput(value: object): value is PartnerEmailInput {
    return true;
}

export function PartnerEmailInputFromJSON(json: any): PartnerEmailInput {
    return PartnerEmailInputFromJSONTyped(json, false);
}

export function PartnerEmailInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerEmailInput {
    if (json == null) {
        return json;
    }
    return {
        
        'language': json['language'] == null ? undefined : LanguageEnumFromJSON(json['language']),
    };
}

export function PartnerEmailInputToJSON(json: any): PartnerEmailInput {
    return PartnerEmailInputToJSONTyped(json, false);
}

export function PartnerEmailInputToJSONTyped(value?: PartnerEmailInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'language': LanguageEnumToJSON(value['language']),
    };
}

